import React from 'react';
import { DuplicatePaymentErrorScreenWrapper } from '../../../DirectPayments/components/DuplicatePaymentErrorScreen/DuplicatePaymentErrorScreenWrapper';
import { useDoublePaymentCheck as useDoublePaymentCheckImport } from '../../hooks/useDoublePaymentCheck/useDoublePaymentCheck';
import { LoadingOverlay } from '../../../../core/screens/LoadingOverlay/LoadingOverlay';

export type DirectPaymentInitiatorProps = {
  useDoublePaymentCheck?: typeof useDoublePaymentCheckImport;
};

export const DirectPaymentInitiator: React.FC<DirectPaymentInitiatorProps> = ({
  children,
  useDoublePaymentCheck = useDoublePaymentCheckImport,
}) => {
  const { loading } = useDoublePaymentCheck();

  if (loading) {
    return <LoadingOverlay />;
  }

  return <DuplicatePaymentErrorScreenWrapper>{children}</DuplicatePaymentErrorScreenWrapper>;
};
